module.exports = __webpack_public_path__ + "static/media/P20_Micropipette.856f03d7.svg";